const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      industries: 'Industries',
      standards: 'Standards',
      safety: 'Safety',
      contact: 'Contact'
    },
    hero: {
      title: 'AnluMAX',
      tagline: 'PASSIONATE ABOUT PROCUREMENT',
      description: 'Specialists in Africa, providing high-quality equipment and tailored solutions for dynamic industries across the continent.',
      exploreBtn: 'Explore Industries',
      contactBtn: 'Get in Touch'
    },
    about: {
      title: 'About AnluMAX',
      subtitle: 'Your Strategic Procurement Partner in Africa',
      description1: 'AnluMAX (Pty) Ltd. is a proud Business Unit of CGES - Group Ecosystem Services. We are specialists in Africa, focusing on the procurement and supply of high-quality equipment for dynamic industries.',
      description2: 'We understand the challenges of the African market and leverage our global supplier connections to provide tailored solutions. Our core values revolve around efficiency, safety, and continuity, ensuring operational continuity and growth for our clients.',
      description3: 'With deep-rooted experience and connections to global suppliers in the UK, Germany, and beyond, we bring intimate knowledge of Africa\'s business landscape combined with agility, transparency, and commitment to long-term relationships.',
      valuesTitle: 'Our Core Values',
      efficiency: 'Efficiency',
      efficiencyDesc: 'Streamlined solutions and end-to-end service from needs assessment to after-sales support',
      safety: 'Safety',
      safetyDesc: 'Rigorous standards addressing demanding operational environments',
      continuity: 'Continuity',
      continuityDesc: 'Commitment to operational continuity and long-term client growth',
      reliability: 'Reliability',
      reliabilityDesc: 'Swift response to complex challenges with durable, compliant solutions'
    },
    industries: {
      title: 'Industries We Serve',
      subtitle: 'Comprehensive equipment solutions tailored for Africa\'s most demanding sectors',
      oilGas: {
        title: 'Oil and Gas',
        description: 'Comprehensive range of high-quality equipment including pressure vessels, heat exchangers, storage tanks, piping systems, and specialized valves. Sourced from reputable manufacturers and certified to the latest industry norms.',
        items: ['Pressure Vessels', 'Heat Exchangers', 'Storage Tanks', 'Piping Systems', 'Specialized Valves']
      },
      mining: {
        title: 'Mining',
        description: 'Diverse array of robust equipment including heavy-duty machinery, material handling systems, crushing and screening units, safety and automation solutions tailored to the demanding mining sector.',
        items: ['Heavy-Duty Machinery', 'Material Handling Systems', 'Crushing & Screening Units', 'Safety Solutions', 'Automation Systems']
      },
      refineries: {
        title: 'Refineries',
        description: 'Extensive selection of advanced equipment including pressure vessels, heat exchangers, distillation columns, pumps, valves, and piping systems. Selected for reliability, safety, and compliance with international standards.',
        items: ['Pressure Vessels', 'Distillation Columns', 'Heat Exchangers', 'Pumps & Valves', 'Piping Systems']
      },
      power: {
        title: 'Power Stations',
        description: 'High-performance equipment tailored to power generation including precision-engineered feedwater heaters, heat exchangers, condensers, pressure vessels, piping systems, and valves compliant with stringent industry standards.',
        items: ['Feedwater Heaters', 'Heat Exchangers', 'Condensers', 'Pressure Vessels', 'Piping & Valves']
      },
      construction: {
        title: 'Construction Sites',
        description: 'Comprehensive procurement service including pre-manufactured modular building equipment, full range of personal protective equipment (PPE), and essential construction site items for efficient project execution.',
        items: ['Modular Buildings', 'PPE Equipment', 'Construction Materials', 'Site Safety Equipment', 'Essential Tools']
      },
      engineering: {
        title: 'General Engineering',
        description: 'Consumables and equipment for diverse industrial applications including forgings, stainless and carbon steel materials, piping materials, flanges, valves, fittings, welding consumables, and precision machining services.',
        items: ['Precision Machining', 'Steel Materials', 'Piping Components', 'Welding Consumables', 'Industrial Lubricants']
      },
      studentAccommodation: {
        title: 'Student Accommodation',
        description: 'Procurement solutions tailored to student housing providers, ensuring safe, affordable, and well-managed living spaces with transparent sourcing, cost-effective contracts, and compliance-ready documentation.',
        items: ['Furniture & Fixtures', 'Cleaning & Hygiene Supplies', 'Security Systems', 'Access Control & CCTV', 'Fire Safety Equipment']
      },
      facilities: {
        title: 'Facilities Management',
        description: 'Comprehensive procurement for facility management across campuses, residences, and shared spaces with streamlined vendor management and sustainable procurement practices aligned with institutional goals.',
        items: ['Building Maintenance', 'Waste Management', 'Landscaping Services', 'Energy Efficiency Upgrades', 'Sustainability Initiatives']
      },
      general: {
        title: 'General Operations',
        description: 'Flexible procurement solutions for everyday operational requirements, covering diverse categories. A one-stop procurement hub ensuring transparency, efficiency, and reliability across all operational needs.',
        items: ['Office Supplies', 'IT Equipment', 'Transportation & Logistics', 'Event Materials', 'Promotional Materials']
      }
    },
    standards: {
      title: 'Standards & Compliance',
      subtitle: 'We insist that all our suppliers and subcontractors comply with the highest international standards',
      items: [
        { name: 'ISO 9001:2015', description: 'Quality Management' },
        { name: 'ISO 45001:2018', description: 'Occupational Health & Safety' },
        { name: 'ISO 3834 Part 2', description: 'Welding Quality Requirements' },
        { name: 'ASME', description: 'American Society of Mechanical Engineers' },
        { name: 'AD Merkblätter', description: 'German Pressure Equipment Standards' }
      ]
    },
    safety: {
      title: 'Safety is a Mindset',
      subtitle: 'Our commitment to safety goes beyond compliance - it\'s embedded in everything we do',
      principles: [
        { title: 'Elective Management', description: 'Robust management structure with legally appointed safety experts' },
        { title: 'Integrated Safety', description: 'Safety, health, and environmental management seamlessly integrated into business decisions' },
        { title: 'Workforce Involvement', description: 'Engagement of workforce in solving health and safety challenges' },
        { title: 'Clear Communication', description: 'Transparent upward communication channels to senior management' },
        { title: 'Risk Management', description: 'Identifying and managing safety risks is fundamental to our approach' },
        { title: 'Performance Accountability', description: 'Regular monitoring, reviewing, and reporting ensure accountability' }
      ]
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Ready to discuss your procurement needs? We\'re here to help.',
      infoTitle: 'Contact Information',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      businessUnit: 'Business Unit',
      businessUnitText: 'AnluMAX (Pty) Ltd. is a proud Business Unit of',
      formTitle: 'Send us a Message',
      nameLabel: 'Name',
      emailLabel: 'Email',
      companyLabel: 'Company',
      messageLabel: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your@email.com',
      companyPlaceholder: 'Your company name',
      messagePlaceholder: 'Tell us about your procurement needs...',
      submitBtn: 'Send Message',
      submittingBtn: 'Sending...',
      successMessage: 'Thank you! Your message has been sent successfully. We will get back to you soon.',
      errorMessage: 'Sorry, there was an error sending your message. Please try again or contact us directly.'
    },
    footer: {
      tagline: 'Passionate about Procurement',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      copyright: 'All rights reserved. A Business Unit of CGES - Group Ecosystem Services.'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      industries: 'Industries',
      standards: 'Normes',
      safety: 'Sécurité',
      contact: 'Contact'
    },
    hero: {
      title: 'AnluMAX',
      tagline: 'PASSIONNÉS PAR LES ACHATS',
      description: 'Spécialistes en Afrique, fournissant des équipements de haute qualité et des solutions sur mesure pour les industries dynamiques à travers le continent.',
      exploreBtn: 'Explorer les Industries',
      contactBtn: 'Nous Contacter'
    },
    about: {
      title: 'À propos d\'AnluMAX',
      subtitle: 'Votre Partenaire Stratégique d\'Approvisionnement en Afrique',
      description1: 'AnluMAX (Pty) Ltd. est une unité commerciale fière de CGES - Group Ecosystem Services. Nous sommes spécialisés en Afrique, en nous concentrant sur l\'approvisionnement et la fourniture d\'équipements de haute qualité pour les industries dynamiques.',
      description2: 'Nous comprenons les défis du marché africain et tirons parti de nos connexions avec des fournisseurs mondiaux pour fournir des solutions sur mesure. Nos valeurs fondamentales tournent autour de l\'efficacité, de la sécurité et de la continuité, assurant la continuité opérationnelle et la croissance de nos clients.',
      description3: 'Avec une expérience profondément enracinée et des connexions avec des fournisseurs mondiaux au Royaume-Uni, en Allemagne et au-delà, nous apportons une connaissance intime du paysage commercial africain combinée à l\'agilité, à la transparence et à l\'engagement envers des relations à long terme.',
      valuesTitle: 'Nos Valeurs Fondamentales',
      efficiency: 'Efficacité',
      efficiencyDesc: 'Solutions rationalisées et service de bout en bout, de l\'évaluation des besoins au support après-vente',
      safety: 'Sécurité',
      safetyDesc: 'Normes rigoureuses répondant aux environnements opérationnels exigeants',
      continuity: 'Continuité',
      continuityDesc: 'Engagement envers la continuité opérationnelle et la croissance des clients à long terme',
      reliability: 'Fiabilité',
      reliabilityDesc: 'Réponse rapide aux défis complexes avec des solutions durables et conformes'
    },
    industries: {
      title: 'Industries que Nous Servons',
      subtitle: 'Solutions d\'équipement complètes adaptées aux secteurs les plus exigeants d\'Afrique',
      oilGas: {
        title: 'Pétrole et Gaz',
        description: 'Gamme complète d\'équipements de haute qualité comprenant des récipients sous pression, des échangeurs de chaleur, des réservoirs de stockage, des systèmes de tuyauterie et des vannes spécialisées. Provenant de fabricants réputés et certifiés selon les dernières normes de l\'industrie.',
        items: ['Récipients sous Pression', 'Échangeurs de Chaleur', 'Réservoirs de Stockage', 'Systèmes de Tuyauterie', 'Vannes Spécialisées']
      },
      mining: {
        title: 'Exploitation Minière',
        description: 'Gamme diversifiée d\'équipements robustes comprenant des machines lourdes, des systèmes de manutention, des unités de concassage et de criblage, des solutions de sécurité et d\'automation adaptées au secteur minier exigeant.',
        items: ['Machines Lourdes', 'Systèmes de Manutention', 'Unités de Concassage et Criblage', 'Solutions de Sécurité', 'Systèmes d\'Automation']
      },
      refineries: {
        title: 'Raffineries',
        description: 'Sélection étendue d\'équipements avancés comprenant des récipients sous pression, des échangeurs de chaleur, des colonnes de distillation, des pompes, des vannes et des systèmes de tuyauterie. Sélectionnés pour la fiabilité, la sécurité et la conformité aux normes internationales.',
        items: ['Récipients sous Pression', 'Colonnes de Distillation', 'Échangeurs de Chaleur', 'Pompes et Vannes', 'Systèmes de Tuyauterie']
      },
      power: {
        title: 'Centrales Électriques',
        description: 'Équipement haute performance adapté à la production d\'énergie, comprenant des réchauffeurs d\'eau d\'alimentation de précision, des échangeurs de chaleur, des condenseurs, des récipients sous pression, des systèmes de tuyauterie et des vannes conformes aux normes strictes de l\'industrie.',
        items: ['Réchauffeurs d\'Eau d\'Alimentation', 'Échangeurs de Chaleur', 'Condenseurs', 'Récipients sous Pression', 'Tuyauterie et Vannes']
      },
      construction: {
        title: 'Chantiers de Construction',
        description: 'Service d\'approvisionnement complet comprenant des équipements de bâtiments modulaires préfabriqués, une gamme complète d\'équipements de protection individuelle (EPI) et des articles essentiels pour chantiers de construction pour une exécution efficace des projets.',
        items: ['Bâtiments Modulaires', 'Équipements EPI', 'Matériaux de Construction', 'Équipement de Sécurité', 'Outils Essentiels']
      },
      engineering: {
        title: 'Ingénierie Générale',
        description: 'Consommables et équipements pour diverses applications industrielles, notamment les pièces forgées, les matériaux en acier inoxydable et en acier au carbone, les matériaux de tuyauterie, les brides, les vannes, les raccords, les consommables de soudage et les services d\'usinage de précision.',
        items: ['Usinage de Précision', 'Matériaux en Acier', 'Composants de Tuyauterie', 'Consommables de Soudage', 'Lubrifiants Industriels']
      },
      studentAccommodation: {
        title: 'Logement Étudiant',
        description: 'Solutions d\'approvisionnement adaptées aux fournisseurs de logements étudiants, garantissant des espaces de vie sûrs, abordables et bien gérés avec un approvisionnement transparent, des contrats rentables et une documentation conforme.',
        items: ['Mobilier et Équipements', 'Fournitures de Nettoyage et d\'Hygiène', 'Systèmes de Sécurité', 'Contrôle d\'Accès et CCTV', 'Équipement de Sécurité Incendie']
      },
      facilities: {
        title: 'Gestion des Installations',
        description: 'Approvisionnement complet pour la gestion des installations sur les campus, résidences et espaces partagés avec une gestion rationalisée des fournisseurs et des pratiques d\'approvisionnement durables alignées sur les objectifs institutionnels.',
        items: ['Maintenance des Bâtiments', 'Gestion des Déchets', 'Services d\'Aménagement Paysager', 'Améliorations de l\'Efficacité Énergétique', 'Initiatives de Durabilité']
      },
      general: {
        title: 'Opérations Générales',
        description: 'Solutions d\'approvisionnement flexibles pour les besoins opérationnels quotidiens, couvrant diverses catégories. Un centre d\'approvisionnement unique garantissant transparence, efficacité et fiabilité pour tous les besoins opérationnels.',
        items: ['Fournitures de Bureau', 'Équipement Informatique', 'Transport et Logistique', 'Matériels d\'Événements', 'Matériels Promotionnels']
      }
    },
    standards: {
      title: 'Normes et Conformité',
      subtitle: 'Nous insistons pour que tous nos fournisseurs et sous-traitants se conforment aux normes internationales les plus élevées',
      items: [
        { name: 'ISO 9001:2015', description: 'Gestion de la Qualité' },
        { name: 'ISO 45001:2018', description: 'Santé et Sécurité au Travail' },
        { name: 'ISO 3834 Partie 2', description: 'Exigences de Qualité de Soudage' },
        { name: 'ASME', description: 'American Society of Mechanical Engineers' },
        { name: 'AD Merkblätter', description: 'Normes Allemandes pour Équipements sous Pression' }
      ]
    },
    safety: {
      title: 'La Sécurité est un État d\'Esprit',
      subtitle: 'Notre engagement envers la sécurité va au-delà de la conformité - c\'est intégré dans tout ce que nous faisons',
      principles: [
        { title: 'Gestion Élective', description: 'Structure de gestion robuste avec des experts en sécurité légalement nommés' },
        { title: 'Sécurité Intégrée', description: 'Gestion de la sécurité, de la santé et de l\'environnement intégrée de manière transparente dans les décisions commerciales' },
        { title: 'Implication du Personnel', description: 'Engagement du personnel dans la résolution des défis de santé et de sécurité' },
        { title: 'Communication Claire', description: 'Canaux de communication ascendante transparents vers la direction générale' },
        { title: 'Gestion des Risques', description: 'L\'identification et la gestion des risques de sécurité sont fondamentales pour notre approche' },
        { title: 'Responsabilité des Performances', description: 'La surveillance, l\'examen et le reporting réguliers assurent la responsabilité' }
      ]
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Prêt à discuter de vos besoins d\'approvisionnement? Nous sommes là pour vous aider.',
      infoTitle: 'Informations de Contact',
      phone: 'Téléphone',
      email: 'E-mail',
      address: 'Adresse',
      businessUnit: 'Unité Commerciale',
      businessUnitText: 'AnluMAX (Pty) Ltd. est une unité commerciale fière de',
      formTitle: 'Envoyez-nous un Message',
      nameLabel: 'Nom',
      emailLabel: 'E-mail',
      companyLabel: 'Société',
      messageLabel: 'Message',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'votre@email.com',
      companyPlaceholder: 'Nom de votre société',
      messagePlaceholder: 'Parlez-nous de vos besoins d\'approvisionnement...',
      submitBtn: 'Envoyer le Message',
      submittingBtn: 'Envoi en cours...',
      successMessage: 'Merci! Votre message a été envoyé avec succès. Nous vous répondrons bientôt.',
      errorMessage: 'Désolé, une erreur s\'est produite lors de l\'envoi de votre message. Veuillez réessayer ou nous contacter directement.'
    },
    footer: {
      tagline: 'Passionnés par les Achats',
      quickLinks: 'Liens Rapides',
      contact: 'Contact',
      copyright: 'Tous droits réservés. Une unité commerciale de CGES - Group Ecosystem Services.'
    }
  },
  pt: {
    nav: {
      home: 'Início',
      about: 'Sobre',
      industries: 'Indústrias',
      standards: 'Padrões',
      safety: 'Segurança',
      contact: 'Contato'
    },
    hero: {
      title: 'AnluMAX',
      tagline: 'APAIXONADOS POR AQUISIÇÕES',
      description: 'Especialistas na África, fornecendo equipamentos de alta qualidade e soluções personalizadas para indústrias dinâmicas em todo o continente.',
      exploreBtn: 'Explorar Indústrias',
      contactBtn: 'Entre em Contato'
    },
    about: {
      title: 'Sobre a AnluMAX',
      subtitle: 'Seu Parceiro Estratégico de Aquisições na África',
      description1: 'AnluMAX (Pty) Ltd. é uma orgulhosa Unidade de Negócios da CGES - Group Ecosystem Services. Somos especialistas na África, focando na aquisição e fornecimento de equipamentos de alta qualidade para indústrias dinâmicas.',
      description2: 'Compreendemos os desafios do mercado africano e aproveitamos nossas conexões com fornecedores globais para fornecer soluções personalizadas. Nossos valores fundamentais giram em torno de eficiência, segurança e continuidade, garantindo continuidade operacional e crescimento para nossos clientes.',
      description3: 'Com experiência profundamente enraizada e conexões com fornecedores globais no Reino Unido, Alemanha e além, trazemos conhecimento íntimo do cenário empresarial africano combinado com agilidade, transparência e compromisso com relacionamentos de longo prazo.',
      valuesTitle: 'Nossos Valores Fundamentais',
      efficiency: 'Eficiência',
      efficiencyDesc: 'Soluções simplificadas e serviço completo desde a avaliação de necessidades até o suporte pós-venda',
      safety: 'Segurança',
      safetyDesc: 'Padrões rigorosos abordando ambientes operacionais exigentes',
      continuity: 'Continuidade',
      continuityDesc: 'Compromisso com a continuidade operacional e crescimento dos clientes a longo prazo',
      reliability: 'Confiabilidade',
      reliabilityDesc: 'Resposta rápida a desafios complexos com soluções duráveis e conformes'
    },
    industries: {
      title: 'Indústrias que Servimos',
      subtitle: 'Soluções de equipamentos abrangentes adaptadas aos setores mais exigentes da África',
      oilGas: {
        title: 'Petróleo e Gás',
        description: 'Gama abrangente de equipamentos de alta qualidade, incluindo vasos de pressão, trocadores de calor, tanques de armazenamento, sistemas de tubulação e válvulas especializadas. Obtidos de fabricantes respeitáveis e certificados de acordo com as últimas normas da indústria.',
        items: ['Vasos de Pressão', 'Trocadores de Calor', 'Tanques de Armazenamento', 'Sistemas de Tubulação', 'Válvulas Especializadas']
      },
      mining: {
        title: 'Mineração',
        description: 'Variedade diversificada de equipamentos robustos, incluindo maquinaria pesada, sistemas de manuseio de materiais, unidades de britagem e peneiramento, soluções de segurança e automação adaptadas ao setor de mineração exigente.',
        items: ['Maquinaria Pesada', 'Sistemas de Manuseio de Materiais', 'Unidades de Britagem e Peneiramento', 'Soluções de Segurança', 'Sistemas de Automação']
      },
      refineries: {
        title: 'Refinarias',
        description: 'Seleção extensa de equipamentos avançados, incluindo vasos de pressão, trocadores de calor, colunas de destilação, bombas, válvulas e sistemas de tubulação. Selecionados pela confiabilidade, segurança e conformidade com padrões internacionais.',
        items: ['Vasos de Pressão', 'Colunas de Destilação', 'Trocadores de Calor', 'Bombas e Válvulas', 'Sistemas de Tubulação']
      },
      power: {
        title: 'Estações de Energia',
        description: 'Equipamento de alto desempenho adaptado para geração de energia, incluindo aquecedores de água de alimentação de precisão, trocadores de calor, condensadores, vasos de pressão, sistemas de tubulação e válvulas em conformidade com rigorosos padrões da indústria.',
        items: ['Aquecedores de Água de Alimentação', 'Trocadores de Calor', 'Condensadores', 'Vasos de Pressão', 'Tubulação e Válvulas']
      },
      construction: {
        title: 'Canteiros de Obras',
        description: 'Serviço de aquisição abrangente, incluindo equipamentos de construção modular pré-fabricados, gama completa de equipamentos de proteção individual (EPI) e itens essenciais para canteiros de obras para execução eficiente de projetos.',
        items: ['Edifícios Modulares', 'Equipamentos EPI', 'Materiais de Construção', 'Equipamento de Segurança', 'Ferramentas Essenciais']
      },
      engineering: {
        title: 'Engenharia Geral',
        description: 'Consumíveis e equipamentos para diversas aplicações industriais, incluindo forjados, materiais de aço inoxidável e aço carbono, materiais de tubulação, flanges, válvulas, acessórios, consumíveis de soldagem e serviços de usinagem de precisão.',
        items: ['Usinagem de Precisão', 'Materiais de Aço', 'Componentes de Tubulação', 'Consumíveis de Soldagem', 'Lubrificantes Industriais']
      },
      studentAccommodation: {
        title: 'Alojamento Estudantil',
        description: 'Soluções de aquisição adaptadas a fornecedores de moradia estudantil, garantindo espaços de convivência seguros, acessíveis e bem gerenciados com fornecimento transparente, contratos econômicos e documentação em conformidade.',
        items: ['Móveis e Equipamentos', 'Suprimentos de Limpeza e Higiene', 'Sistemas de Segurança', 'Controle de Acesso e CFTV', 'Equipamento de Segurança Contra Incêndio']
      },
      facilities: {
        title: 'Gestão de Instalações',
        description: 'Aquisição abrangente para gestão de instalações em campi, residências e espaços compartilhados com gestão simplificada de fornecedores e práticas de aquisição sustentáveis alinhadas com objetivos institucionais.',
        items: ['Manutenção de Edifícios', 'Gestão de Resíduos', 'Serviços de Paisagismo', 'Melhorias de Eficiência Energética', 'Iniciativas de Sustentabilidade']
      },
      general: {
        title: 'Operações Gerais',
        description: 'Soluções de aquisição flexíveis para necessidades operacionais do dia a dia, cobrindo diversas categorias. Um centro de aquisições único que garante transparência, eficiência e confiabilidade em todas as necessidades operacionais.',
        items: ['Material de Escritório', 'Equipamento de TI', 'Transporte e Logística', 'Materiais para Eventos', 'Materiais Promocionais']
      }
    },
    standards: {
      title: 'Padrões e Conformidade',
      subtitle: 'Insistimos que todos os nossos fornecedores e subcontratados cumpram os mais altos padrões internacionais',
      items: [
        { name: 'ISO 9001:2015', description: 'Gestão da Qualidade' },
        { name: 'ISO 45001:2018', description: 'Saúde e Segurança Ocupacional' },
        { name: 'ISO 3834 Parte 2', description: 'Requisitos de Qualidade de Soldagem' },
        { name: 'ASME', description: 'American Society of Mechanical Engineers' },
        { name: 'AD Merkblätter', description: 'Padrões Alemães de Equipamentos sob Pressão' }
      ]
    },
    safety: {
      title: 'Segurança é uma Mentalidade',
      subtitle: 'Nosso compromisso com a segurança vai além da conformidade - está incorporado em tudo o que fazemos',
      principles: [
        { title: 'Gestão Eletiva', description: 'Estrutura de gestão robusta com especialistas em segurança legalmente nomeados' },
        { title: 'Segurança Integrada', description: 'Gestão de segurança, saúde e meio ambiente perfeitamente integrada às decisões de negócios' },
        { title: 'Envolvimento da Força de Trabalho', description: 'Engajamento da força de trabalho na resolução de desafios de saúde e segurança' },
        { title: 'Comunicação Clara', description: 'Canais de comunicação ascendente transparentes para a alta gestão' },
        { title: 'Gestão de Riscos', description: 'Identificar e gerenciar riscos de segurança é fundamental para nossa abordagem' },
        { title: 'Responsabilidade de Desempenho', description: 'Monitoramento, revisão e relatórios regulares garantem responsabilidade' }
      ]
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Pronto para discutir suas necessidades de aquisição? Estamos aqui para ajudar.',
      infoTitle: 'Informações de Contato',
      phone: 'Telefone',
      email: 'E-mail',
      address: 'Endereço',
      businessUnit: 'Unidade de Negócios',
      businessUnitText: 'AnluMAX (Pty) Ltd. é uma orgulhosa Unidade de Negócios da',
      formTitle: 'Envie-nos uma Mensagem',
      nameLabel: 'Nome',
      emailLabel: 'E-mail',
      companyLabel: 'Empresa',
      messageLabel: 'Mensagem',
      namePlaceholder: 'Seu nome',
      emailPlaceholder: 'seu@email.com',
      companyPlaceholder: 'Nome da sua empresa',
      messagePlaceholder: 'Conte-nos sobre suas necessidades de aquisição...',
      submitBtn: 'Enviar Mensagem',
      submittingBtn: 'Enviando...',
      successMessage: 'Obrigado! Sua mensagem foi enviada com sucesso. Entraremos em contato em breve.',
      errorMessage: 'Desculpe, ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente ou entre em contato diretamente.'
    },
    footer: {
      tagline: 'Apaixonados por Aquisições',
      quickLinks: 'Links Rápidos',
      contact: 'Contato',
      copyright: 'Todos os direitos reservados. Uma Unidade de Negócios da CGES - Group Ecosystem Services.'
    }
  }
};

export const languageNames = {
  en: 'English',
  fr: 'Français',
  pt: 'Português'
};

export default translations;
